export const JOB_OFFER_ID = 'jobOfferId';
